import CrudApi from './crud';

export const crud = new CrudApi('/admin/notifications', { only: ['index', 'store', 'update', 'show'] });
